










import { Component, Prop, Vue } from 'vue-property-decorator'
import * as graph from '@shared/types/graphql'
import ClientUploadDisplay from '@/components/ClientUploads/ClientUploadDisplay.vue'

@Component({
  components: {
    ClientUploadDisplay
  }
})
export default class ClientUploadDisplays extends Vue {
  @Prop({ required: true }) uploads!: graph.Prototype[]
}
